import { changeDictionaries, orgKindList, orgTyleList, cooperationList, completeStatusList } from '@/utils/dictionary.js';
// 基础信息和企业经营信息的表单参数
export const formValidate = {
  /* ---- 基本信息 start ----*/
  orgName: '', // 服务名称
  orgType: '', // 服务类型 服务类型 1民企2国企3个体4其他
  orgMode: 1,
  orgTradeType: '', // 商户类型 1:企业 2：平台 3：个人
  orgTradeKind: '', // 商户身份
  orgArea: '', // 所属地区
  areaId: [], // 所属地区 new
  /* ---- 基本信息 end ----*/
  /* ---- 企业经营信息 start ----*/
  businessName: '', // 品牌名/企业简称 new
  corporation: '', // 法人代表姓名
  businessAddr: '', // 注册地址
  businessType: '', // 营业执照类型
  businessLicense: '', // 营业执照证件号
  businessDate: [], // 营业期限
  businessStartDate: '', // 营业期限
  businessEndDate: '', // 营业期限
  businessPhone: '', // 办公电话
  businessScope: '', // 经营范围
  businessPhotoBefore: [], // 没上传给接口之前的营业执照图片
  businessPhoto: '' // 证件照片
  /* ---- 企业经营信息 end ----*/
};
// 基本信息和企业经营信息表单验证规则
export const ruleValidate = {
  /* ---- 基本信息 start ----*/
  orgName: [{ required: true, message: '请输入服务名称', trigger: 'blur' }],
  orgType: [
    {
      required: true,
      type: 'number',
      message: '请选择服务类型',
      trigger: 'change'
    }
  ],
  orgTradeType: [
    {
      required: true,
      type: 'number',
      message: '请选择商户类型',
      trigger: 'change'
    }
  ],
  orgTradeKind: [
    {
      required: true,
      type: 'number',
      message: '请选择商户身份',
      trigger: 'change'
    }
  ],
  areaId: [
    {
      required: true,
      type: 'array',
      message: '请选择所属地区',
      trigger: 'change'
    }
  ],
  /* ---- 基本信息 end ----*/
  /* ---- 企业经营信息 start ----*/
  businessName: [
    { required: true, message: '请输入品牌名/企业简称', trigger: 'blur' }
  ],
  corporation: [
    { required: true, message: '请输入法人代表姓名', trigger: 'blur' }
  ],
  businessAddr: [
    { required: true, message: '请输入注册地址', trigger: 'blur' }
  ],
  businessType: [
    {
      required: true,
      type: 'number',
      message: '请选择证件类型',
      trigger: 'change'
    }
  ],
  businessLicense: [
    { required: true, message: '请输入证件号码', trigger: 'blur' }
  ],
  businessDate: [
    {
      required: true,
      type: 'array',
      message: '请选择时间段',
      trigger: 'change'
    }
  ],
  businessPhone: [
    { required: true, message: '请输入办公电话', trigger: 'blur' }
  ],
  businessScope: [
    { required: true, message: '请输入经营范围', trigger: 'blur' }
  ],
  businessPhotoBefore: [
    {
      required: true,
      type: 'array',
      message: '请上传证件照片',
      trigger: 'blur'
    }
  ]
  /* ---- 企业经营信息 end ----*/
};
// 管理员信息表单参数
export const operatorFormValidate = {
  // 1：EDU_TYPE    ：   教育局
  // 2：SCHOOL_TYPE  ： 学校
  // 3：ORG_TYPE  ： 学习服务
  // 4：FOOD_ORG_TYPE  ： 餐饮服务
  // 5：OPERATOR_TYPE   ： 运营平台
  operatorTypeEnum: 'ORG_TYPE', // 1:教育局 2：学校 3：服务 4：餐饮服务 5：运营用户
  userType: 1, // 个人身份
  operatorCode: '', // 操作员账号
  operatorName: '', // 操作员姓名
  password: '', // 登录密码
  operatorRole: 'SYSTEM_ROLE', // 操作员角色  默认管理员
  operatorPhone: '', // 手机号码
  operatorAddr: '', // 联系地址
  email: '', // 邮箱地址
  idType: '', // 证件类型
  idNo: '', // 证件号码
  operatorIdentifyDate: [], // 证件有效期限
  idStartDate: '', // 证件开始日期
  idEndDate: '', // 证件结束日期
  operatorIdentifyCard: [], // 管理员证件照片
  idPhoto: '', // 管理员证件照片
  orgId: '', // 操作员默认组织id
  opSts: 1, // 是否启用
  msgCode: '' // 手机验证码
};
// 管理员信息表单验证
export const operatorRuleValidate = {
  operatorName: [
    { required: true, message: '请输入管理员姓名', trigger: 'blur' }
  ],
  userType: [
    {
      required: true,
      type: 'number',
      message: '请选择个人身份',
      trigger: 'change'
    }
  ],
  operatorPhone: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    {
      pattern: /^1[0-9]{10}$/,
      message: '手机号格式不正确！',
      trigger: 'blur'
    }
  ],
  msgCode: [{ required: true, message: '请输入手机验证码', trigger: 'blur' }],
  operatorAddr: [
    { required: true, message: '请输入联系地址', trigger: 'blur' }
  ],
  email: [{ required: true, message: '请输入邮箱地址', trigger: 'blur' }],
  idNo: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
  idType: [
    {
      required: true,
      type: 'number',
      message: '请选择证件类型',
      trigger: 'change'
    }
  ],
  operatorIdentifyDate: [
    {
      required: true,
      type: 'array',
      message: '请选择时间段',
      trigger: 'change'
    }
  ],
  operatorIdentifyCard: [
    {
      required: true,
      type: 'array',
      message: '请上传证件照片',
      trigger: 'blur'
    }
  ],
  operatorCode: [
    { required: true, message: '请输入管理员用户名', trigger: 'blur' }
  ],
  password: [{ required: true, message: '请输入管理员密码', trigger: 'blur' }],
  opSts: [
    {
      required: true,
      message: '请选择是否启用',
      trigger: 'change'
    }
  ]
};

// 校区管理表格表头
export const branchDataColumn = [
  {
    // type: 'index',
    title: '校区代码',
    align: 'center',
    key: 'branchId'
  },
  {
    title: '校区名称',
    align: 'center',
    key: 'branchName'
  },
  {
    title: '区域',
    align: 'center',
    key: 'area'
  },
  {
    title: '地址',
    align: 'center',
    key: 'address'
  },
  {
    title: '校区电话',
    align: 'center',
    key: 'branchPhone'
  },
  {
    title: '校区座机',
    align: 'center',
    key: 'branchTellphone'
  },
  {
    title: '创建时间',
    align: 'center',
    key: 'createTime'
  },
  {
    title: '操作',
    slot: 'action',
    width: 250,
    align: 'center'
  }
];
// 添加编辑校区的表单参数
export const branchModalFormValidate = {
  branchName: '',
  area: '',
  areaIdArray: [],
  address: '',
  branchPhone: '',
  branchTellphone: ''
};
// 添加校区表单验证规则
export const branchModalRuleValidate = {
  branchName: [{ required: true, message: '请输入校区名称', trigger: 'blur' }],
  areaIdArray: [
    {
      required: true,
      type: 'array',
      message: '请选择',
      trigger: 'change'
    }
  ]
};

// 运营端-教育局-教育局列表-查询表单
export const opeEduListSearchFormValidate = {
  searchStr: '', //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
  orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
  areaCode: '', // 所属行政区
  infoSts: null, // 信息完善状态 0：待完善 1：信息完善
  coSts: null, // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
  pageNum: 1, // 默认为1
  pageSize: 20
};

// 运营端-服务-服务列表-查询表单
export const opeOrgListSearchFormValidate = {
  keywords: '', // 单位全称、简称、组织机构代码、联系人姓名、手机号等
  orgType: '', // 单位类别
  area: '', // 总部区域
  coopStu: '', // 合作状态
  infoStu: '' // 信息完善状态
};

// 运营端-服务-服务列表 表格表头
export const opeOrgListColumns = [
  {
    title: '单位名称',
    key: 'orgName',
    align: 'center'
  }, {
    title: '单位类型',
    key: 'orgKind',
    align: 'center'
  }, {
    title: '单位类别',
    key: 'orgType',
    align: 'center'
  }, {
    title: '组织机构代码',
    key: 'orgCode',
    align: 'center'
  }, {
    title: '总部区域',
    key: 'area',
    align: 'center'
  }, {
    title: '单位联系人',
    key: 'concat',
    align: 'center'
  }, {
    title: '详细地址',
    key: 'address',
    align: 'center'
  }, {
    title: '合作状态',
    key: 'coopStatus',
    align: 'center'
  }, {
    title: '信息完善状态',
    key: 'infoStatus',
    align: 'center'
  }, {
    title: '更新时间',
    key: 'updateTime',
    align: 'center'
  }
];
